import { effects } from 'redux-saga'

import { beginWork } from '../../modules/signupEdit/actions'

import callWithHmac from "internal-components/src/redux/sagas/effects/callWithHmac";

export default function* handleSubmitHeardAbout(apis, action) {
  const signup = action.payload.signupWithExternals.signup

  yield effects.put.resolve(beginWork())

  yield effects.call(
    callWithHmac,
    apis.invocation.submitHeardAbout,
    signup,
    action.payload.heardAbout
  )

  return true
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/handleSubmitHeardAbout.js